import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { CustomerType } from '../types/customer-type';
import { Hub } from '../types/hub';
import { HubInformation } from '../types/hub-information';
import { InstallationState } from '../types/installation-state';
import { Installer } from '../types/installer';
import { Shipment } from '../types/shipment';
import { StockLocation } from '../types/stock-location';
import { StockOfficeStatus } from '../types/stock-office-status';
import { StockStatus } from '../types/stock-status';


@Component({
  selector: 'hub-information',
  templateUrl: './hub-information.component.html',
  styleUrls: ['./hub-information.component.css'],
  providers: [ HubService ],
})

export class HubInformationComponent implements OnInit {
  @Input() inHub: Hub;
  @Output() information_saved = new EventEmitter<boolean>();
  hub: Hub;
  hubInformation = {} as HubInformation;
  customer_types = [] as CustomerType[];
  installation_states = [] as InstallationState[];
  stock_statuses = [] as StockStatus[];
  stock_locations = [] as StockLocation[];
  installer_list = [] as Installer[];
  shipment_list = [] as Shipment[];
  stockOfficeStatus = [] as StockOfficeStatus[];
  errorMessages: string[];
  editable = false;

  postCode: string;
  phone: string;
  mobile: string;

  constructor(
    private hubService: HubService,
  ) {}

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }

    try {
      this.hubService.getLookupTable('customer_types').subscribe(
        lookup_values => this.customer_types = <CustomerType[]>lookup_values,
        error => this.errorMessages = <any>error,
      );
      this.hubService.getLookupTable('installation_states').subscribe(
        lookup_values => this.installation_states = <InstallationState[]>lookup_values,
        error => this.errorMessages = <any>error,
      );
      this.hubService.getLookupTable('stock_statuses').subscribe(
        lookup_values => this.stock_statuses = <StockStatus[]>lookup_values,
        error => this.errorMessages = <any>error,
      );
      this.hubService.getLookupTable('stock_locations').subscribe(
        lookup_values => this.stock_locations = <StockLocation[]>lookup_values,
        error => this.errorMessages = <any>error,
      );
      this.hubService.getLookupTable('installers').subscribe(
        lookup_values => this.installer_list = <Installer[]>lookup_values,
        error => this.errorMessages = <any>error,
      );
      this.hubService.getLookupTable('shipment').subscribe(
        lookup_values => this.shipment_list = <Shipment[]>lookup_values,
        error => this.errorMessages = <any>error,
      );
      this.hubService.getLookupTable('stock_office_status').subscribe(
        lookup_values => this.stockOfficeStatus = <StockOfficeStatus[]>lookup_values,
        error => this.errorMessages = <any>error,
      );

      //console.log(this.hubInformation.installer_id);
      //this.hubInformation.installer_name = this.getInstallerName(this.hubInformation.installer_id);
      //console.log(this.hubInformation.installer_name);

    } catch (e) {
      console.log('Meh: ' + e);
    }

    this.switchHub();
  }

  prettyPostcode(postcode: string): string {
    console.log('postcode prettifier with length ' + postcode.length);
    if (postcode.length === 7 || postcode.length === 6) {
      return (postcode.slice(0, 3) + ' ' + postcode.slice(3)).toUpperCase();
    }
    return postcode;
  }

  savePostcode(value: string): string {
    console.log('postcode setter with length ' + value.length);
    if (value.length > 6 && value.length < 9 && value.match(/^[A-Z0-9]{3,4} ?[A-Z0-9]{3,4}$/i)) {
      value = value.replace(/[^A-Z0-9]/g, '').toUpperCase();
    }
    return value;
  }

  getAreaCode(phone: string): string {
    let areacode = phone[0];
    if (areacode !== '1') {
      areacode += phone[1];
      if (areacode[1] === '0' || areacode === '82') {
        areacode += phone[2];
      }
    }
    return areacode;
  }

  getInstallerName(value: number): string {
    console.log("In here................")
    for (let installer of this.installer_list) {
        if (installer.installer_id == value){
            console.log(installer.installer_name);
            return installer.installer_name;
        }
    }
    return "unknown";
  }

  prettyPhone(inPhone: string): string {
    let phone = inPhone.replace(/[^0-9+]/g, '');
    if (phone.match(/^(00|[+])?353.{8,12}$/)) {
      phone = phone.slice(phone.indexOf('353') + 3).replace(/\+/g, '');
      console.log('Irish phone number +353....' + phone);
      if (phone[0] === '0') { phone = phone.slice(1); }
      let areacode = this.getAreaCode(phone);
      phone = phone.slice(areacode.length);
      return '+353 (' + areacode + ') ' + phone.slice(0, phone.length - 4) + ' ' + phone.slice(phone.length - 4);
    }
    if (phone.match(/^0[0-9]{1,3}.{6,12}$/)) {
      phone = phone.slice(1).replace(/\+/g, '');
      console.log('Irish phone number 0....' + phone);
      let areacode = this.getAreaCode(phone);
      phone = phone.slice(areacode.length);
      return '+353 (' + areacode + ') ' + phone.slice(0, phone.length - 4) + ' ' + phone.slice(phone.length - 4);
    }
    console.log('Unrecognised phone number format: ' + inPhone + ', ' + phone);
    return inPhone;
  }

  savePhone(value: string): string {
    return value.replace(/[^+0-9]/g, '');
  }


  switchHub(): void {
    if (!this.inHub) { this.inHub = new Hub(); }
    this.hub = Object.assign({}, this.inHub);  // Clone

    this.hubService.getHubInformation(this.hub.hubid)
      .subscribe(
      hubInfo => {
        if (!hubInfo.stock_location_id) {
          hubInfo.stock_location_id = 1;
          hubInfo.stock_status_id = 1;
          hubInfo.customer_type_id = this.hub.customer_type_id;
          hubInfo.installation_state_id = 1;
          hubInfo.name = this.hub.name;
          hubInfo.address = this.hub.address;
          hubInfo.city = this.hub.city;
          hubInfo.country = 'Ireland';
          hubInfo.dispatched = '';
          hubInfo.installed = '';
          hubInfo.installer_name = this.getInstallerName(this.hubInformation.installer_id);
        }
        if (!hubInfo.name) { hubInfo.name = ''; }
        if (!hubInfo.installed) { hubInfo.installed = ''; }
        if (!hubInfo.dispatched) { hubInfo.dispatched = ''; }
        try {
          hubInfo.installed = hubInfo.installed.substring(0, 10);
          hubInfo.dispatched = hubInfo.dispatched.substring(0, 10);
        } catch (e) {
          console.log('Error substringing!' + e.message);
        }
        this.hubInformation = hubInfo;
        this.postCode = this.prettyPostcode(hubInfo.postcode);
        this.phone = this.prettyPhone(hubInfo.contact_phone);
        this.mobile = this.prettyPhone(hubInfo.contact_mobile);
        try {
          AppComponent.SetTitle(this.hubInformation.name + ' (' + this.hub.hubid + ')');
        } catch (e) {}
      },
      error => this.errorMessages = <any>error,
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName of Object.keys(changes)) {
      // console.log('Property ' + propName + ' changed');
      switch (propName) {
        case 'inHub':
          this.switchHub();
          break;
      }
    }
  }

  isValid(): boolean {
    let errors = <string[]>[];
    const early_install_date = Date.parse('2014-01-01');

    if (this.hubInformation.installation_state_id >= 4 && this.hubInformation.installation_state_id <= 6) {
      if (!this.hubInformation.installed || Date.parse(this.hubInformation.installed) < early_install_date) {
        errors.push(`The installation date should be set (estimate, if not known)`);
      }
    } else if (this.hubInformation.installed) {
      if (Date.parse(this.hubInformation.installed) < early_install_date) {
        errors.push(`The installation date should be real, or empty.`);
      }
    }

    if (this.hubInformation.dispatched) {
      if (Date.parse(this.hubInformation.dispatched) < early_install_date) {
        errors.push(`The dispatched date should be real, or empty.`);
      }
    }

    if (errors) {
      this.errorMessages = errors;
    } else {
      this.errorMessages = <string[]>[];
    }
    return (errors.length === 0);
  }

  save(): void {
    if (!!this.hub && !this.hubInformation.hubid) {
      this.hubInformation.hubid = this.hub.hubid;
    }
    if (!this.hubInformation.installation_state_id || this.hubInformation.installation_state_id < 1) {
      this.hubInformation.installation_state_id = 1;
    }
    if (!this.hubInformation.stock_location_id || this.hubInformation.stock_location_id < 1) {
      this.hubInformation.stock_location_id = 1;
    }
    if (!this.hubInformation.stock_status_id || this.hubInformation.stock_status_id < 1) {
      this.hubInformation.stock_status_id = 1;
    }
    if (!this.hubInformation.customer_type_id || this.hubInformation.customer_type_id < 1) {
      this.hubInformation.customer_type_id = 1;
    }
    if (this.hubInformation.installed === '') {
      this.hubInformation.installed = undefined;
    }
    if (this.hubInformation.dispatched === '') {
      this.hubInformation.dispatched = undefined;
    }
    if (this.postCode) {
      this.hubInformation.postcode = this.savePostcode(this.postCode);
    }
    this.hubInformation.stock_docket_number = +this.hubInformation.stock_docket_number;
    this.hubInformation.carton_number = +this.hubInformation.carton_number;
    this.hubInformation.installer_id = +this.hubInformation.installer_id;

    this.hubInformation.contact_phone = this.savePhone(this.phone);
    this.hubInformation.contact_mobile = this.savePhone(this.mobile);
      
    this.hubService.writeInformation(this.hubInformation)
      .subscribe(() => {
        this.switchHub();
        this.editable = false;
        this.information_saved.emit(true);
      });
  }

  openGoogleMaps(event: Event, postcode: string) {
    window.open(`https://www.google.ie/maps/search/${postcode}`, postcode);
    event.stopImmediatePropagation();
  }

  edit(): void {
    this.editable = true;
  }

  cancel(): void {
    this.editable = false;
    this.switchHub();
  }
}
